import { CellProps } from 'react-table';
import CustomIconButton from '../../../../component/custom-icon-button/CustomIconButton';

const ActionsCell = ({ row, tableOptions }: CellProps<any>) => {
	const { handleDelete, setSelectedRow } = tableOptions;

	return (
		<div className="d-flex justify-content-center">
			<CustomIconButton
				variant="delete"
				onClick={() => {
					handleDelete?.();
					setSelectedRow?.(row.index);
				}}
			>
				<i className="bi bi-trash3-fill text-danger"></i>
			</CustomIconButton>
		</div>
	);
};

export default ActionsCell;
